<!-- <p>product-filter-sidebar works!</p> -->
<fb-filter-config-sidebar
		[controls]="controls"
		(onControlChange)="seekFilterChanges()"
	class="w-full md:w-[350px]"></fb-filter-config-sidebar>
